import type { SchoolTestApi } from '@mathflat/domain/@entities/(Content)/SchoolTest/api'
import type { CurriculumApi } from '@mathflat/domain/@entities/Curriculum/api'

import { mpEventInfo } from '@/constant'
import type { DefaultResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

// 단원-유형 API
const curriculumApi = {
  getCurriculum: (params: { idSet: number[]; type: 'LITTLE_CHAPTER' | 'CONCEPT' }) => {
    return maxios.get<DefaultResponse<CurriculumApi.Response.CurriculumInfo[]>>(`/curriculums`, {
      params: { ...params, mp_event_name: mpEventInfo.학습지만들기2단계_소단원별개념조회 },
    })
  },
  getCurriculumTreeList: () => {
    return maxios.get<DefaultResponse<res.Curriculum>>(`/curriculums/tree`, {
      params: { mp_event_name: mpEventInfo.학습지교재만들기_새문제추가_단원트리 },
    })
  },

  getCurriculumTreeByTrieKey: (trieKey: string) => {
    return maxios.get<CurriculumApi.Response.CurriculumTreeFilteByConceptAndChapter[]>(
      `/curriculums/by-key`,
      {
        params: { mp_event_name: mpEventInfo.학습지만들기2단계_소단원별개념조회, key: trieKey },
      },
    )
  },
  getCurriculumTreeGroups: (depth = 1) => {
    return maxios.get<DefaultResponse<res.Curriculum[]>>(`/curriculums/tree/group/${depth}`, {
      params: { mp_event_name: mpEventInfo.단원별취약유형관리_단원트리 },
    })
  },

  getTopicAndSubTopic: (conceptId: number) => {
    return maxios.get<CurriculumApi.Response.Topic[]>(`/concepts/${conceptId}/sub-topics`)
  },
  getCurriculumCore: () => {
    return maxios.get<DefaultResponse<CurriculumApi.Response.CurriculumCore>>(`/curriculums/core`)
  },
  getCurriculumsBySchoolTestIds: async (params: SchoolTestApi.Request.SchoolTestGroupBySchool) => {
    return maxios.get<CurriculumApi.Response.CurriculumTreeFilter[]>('curriculums/by-school-test', {
      params,
    })
  },
}

export default curriculumApi
